"use client";

import { getNpsThemeClasses } from "@repo/nps/branded";
import { HeadlineText } from "@repo/ui/typography";
import { twMerge } from "tailwind-merge";
import Image, { type StaticImageData } from "next/image";
import type { NpsCopy } from "../types";

interface ThankYouProps {
  copy: NpsCopy;
  thankYouIllustration?: StaticImageData;
}

export function ThankYou({ copy, thankYouIllustration }: ThankYouProps) {
  const themeClasses = getNpsThemeClasses();

  return (
    <div className="flex flex-col gap-[24px] items-center justify-center w-full min-h-[200px]">
      {thankYouIllustration && (
        <div className="flex items-center justify-center w-full">
          <Image
            alt="Thank you illustration"
            src={thankYouIllustration}
            className="object-contain"
            width={200}
            height={200}
            unoptimized
          />
        </div>
      )}
      <HeadlineText
        className={twMerge(
          themeClasses.title,
          "text-center text-[20px] leading-[28px] tracking-[0.2px] w-full"
        )}
      >
        {copy.confirmation}
      </HeadlineText>
    </div>
  );
}
